module.exports = __webpack_public_path__ + "static/img/govcard_06.20e6633e.svg";